export default {
  // 取得 vuex 內 postWallData 資料(目前貼文牆上已取得的貼文資料)
  getPostWallData: state => {
    return state.postWallData;
  },
  // 取得目前 load 到貼文牆的第幾頁
  getNowPageIndex: state => {
    return state.postPageIndex;
  },
  // 取得目前是否已 load 完 API 請求
  getPostWallLoadStatus: state => {
    return state.isFinishLoad;
  }
};
